import { alpha } from '@theme-ui/color'

const desktopTabletMinHeight = '36em'
const tabletMinWidth = '48em'
const desktopMinWidth = '70em'

const breakpoints = [
  `@media screen and (min-width: ${tabletMinWidth}) and (min-height: ${desktopTabletMinHeight})`,
  `@media screen and (min-width: ${desktopMinWidth}) and (min-height: ${desktopTabletMinHeight})`,
]

const colors = {
  neonGreen: '#55FF8A',
  neonGreen50: alpha('neonGreen', 0.5),
  neonGreen25: alpha('neonGreen', 0.25),
  neonGreen10: alpha('neonGreen', 0.1),
  windscribeBlue: '#006aff',
  windscribeBlue50: alpha('windscribeBlue', 0.5),
  windscribeBlue25: alpha('windscribeBlue', 0.25),
  windscribeBlue10: alpha('windscribeBlue', 0.1),
  midnight: '#020d1c',
  midnight50: alpha('midnight', 0.25),
  bodyBG: '#041d3e',
  garryBackground: '#0e1f36',
  red: '#e33f3f',
  yellow: '#ffef02',
  periwinkle: '#8d6cff',
  periwinkle50: alpha('periwinkle', 0.5),
  periwinkle25: alpha('periwinkle', 0.25),
  white: '#ffffff',
  white50: alpha('white', 0.5),
  white25: alpha('white', 0.25),
  white15: alpha('white', 0.15),
  white10: alpha('white', 0.1),
  black30: alpha('black', 0.3),
  gray: '#efefef',
}

const variants = {
  buttons: {
    primary: { cursor: 'pointer' },
    neon: {
      cursor: 'pointer',
      height: '48px',
      borderRadius: '40px',
      padding: '12px 24px 12px 24px',
      backgroundColor: 'neonGreen',
      justifyContent: 'center',
      alignItems: 'center',
      '&:disabled': {
        border: 'none',
        backgroundColor: 'white10',
        '& > span': {
          color: 'white25',
        },
      },
    },
    transparent: {
      cursor: 'pointer',
      padding: 0,
      margin: 0,
      backgroundColor: 'transparent',
    },
  },
}

export default { breakpoints, colors, ...variants }
